/**
 * Colours for editable layers, shared by the map and the panel that lists them.
 *
 * Keyed off the layer's own id rather than its position in the list, so a
 * layer keeps its colour when another is switched off, deleted, or uploaded
 * beside it. Position-based assignment recoloured half the map every time the
 * list changed, which made the swatch in the panel useless as a way of finding
 * a layer's geometry among several.
 *
 * The palette must never share a hue with anything else on the map, so an
 * uploaded overlay is never mistaken for survey data. Taken (MapPreview
 * COLORS / PROGRESS_COLORS): amber points and orange polygons (field data),
 * teal (unnumbered outlines), white (revisit), yellow blocks, violet wards,
 * cyan zones, orange / green survey progress, rose / fuchsia QA marks. The
 * earlier palette had orange-red, emerald and dark cyan, which read as field
 * data, unnumbered outlines and zones. What is left is blue, navy, pink,
 * slate, brown and lime -- keep it that way when adding a colour.
 */
export const EDITABLE_COLORS = [
  "#2563EB", // blue
  "#DB2777", // pink
  "#1E3A8A", // navy
  "#65A30D", // lime
  "#475569", // slate
  "#7C2D12", // brown
];

export function editableLayerColor(layerId: number): string {
  return EDITABLE_COLORS[Math.abs(layerId) % EDITABLE_COLORS.length];
}
